import AddMyCompanySitePage from './AddMyCompanySite';
import { createAddMyCompanySiteHandle } from './handle';

export default {
  Component: AddMyCompanySitePage,
  createHandle: createAddMyCompanySiteHandle
};
